import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Field, useField } from 'react-final-form';
import { Col, Label, Row, Select, Selection } from '@folio/stripes-components';
import { useIntl } from 'react-intl';
import { required } from '../../../utils/utils';
import useDataByName from '../../../hooks/useDataByName';
import HelpeModal from '../../HelpeModal';
import css from '../styles.css';

const propTypes = {
  fieldValues: PropTypes.object,
  index: PropTypes.number,
  fieldName: PropTypes.string,
  parentField: PropTypes.object,
  showHelpeIcon: PropTypes.bool,
  controlledVocab: PropTypes.object,
};

function SelectFieldComponent({
  fieldValues,
  index,
  fieldName,
  parentField,
  showHelpeIcon,
  controlledVocab,
}) {
  const {
    name,
    label,
    type,
    isRequired,
    canEdit,
    isRepeatable,
    dataOptionsLimits,
    dataOptionsSource,
    defaultValue,
    tableName,
    schema,
    fieldDataOption,
  } = fieldValues;

  // const data = useDataByName(dataOptionsSource);
  const data = controlledVocab[dataOptionsSource];

  const { locale, formatMessage } = useIntl();
  const fieldLabel = label.find((field) => field.locale === locale)?.value;
  const intl = useIntl();

  const handleDataOptions = () => {
    const fieldOptions = [];
    (data || []).forEach((opt) => {
      fieldOptions.push({ value: opt.id, label: opt.name });
    });

    if (schema === 'default') {
      return fieldOptions;
    } else {
      return fieldDataOption;
    }
  };

  const defaultValueFormatter = () => {
    const defaultData = dataOptionsLimits?.length
      ? dataOptionsLimits
      : handleDataOptions();

    if (schema === 'default') {
      return defaultData?.map((opt) => ({
        label: intl.formatMessage({
          id: `ui-inventory.${tableName || dataOptionsSource}.name.${
            opt.label
          }`,
          defaultMessage: opt.label,
        }),
        value: opt.value,
      }));
    }

    return defaultData?.map((opt) => ({
      label: opt.label.find((loc) => loc.locale === intl.locale)?.value,
      value: opt.value,
    }));
  };

  const handleFieldLabelAppeerance = () => {
    if (isRepeatable || (parentField?.type === 'fieldArray' && index !== 0)) {
      return null;
    }
    return <Label fullWidth>{fieldLabel}</Label>;
  };

  const containerCondition =
    parentField?.type !== 'fieldArray' && !isRepeatable;

  return (
    <Row className={containerCondition ? css.container : ''}>
      <Col xs={showHelpeIcon ? 11 : 12}>
        <Field
          id={`inventory-templates-form-generator-${type}-field-${index}`}
          component={Selection}
          fullWidth
          name={fieldName}
          // subscription={{ value: true }}
          label={handleFieldLabelAppeerance()}
          dataOptions={[
            {
              label: formatMessage(
                {
                  id: 'ui-plugin-inventory-templates.formGenerator.selectField.chooseMsg',
                  defaultMessage: 'Choose {fieldLabel}',
                },
                { fieldLabel },
              ),
              value: '',
            },
            ...defaultValueFormatter(),
          ]}
          // initialValue={defaultValue}
          required={isRequired}
          validate={isRequired ? required : () => undefined}
          type="text"
          disabled={!canEdit}
          parse={(value) => (value === '' ? null : value)} // Fix issue: Empty values don't appear in values
        />
      </Col>
      {showHelpeIcon && (
        <Col xs={1} className={css.margin_btn}>
          <HelpeModal
            fieldData={fieldValues}
            title={fieldLabel}
            iconSize="medium"
          />
        </Col>
      )}
    </Row>
  );
}

SelectFieldComponent.propTypes = propTypes;

export default SelectFieldComponent;
